import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { queryClient } from "@shared/query/client";
import { AuthInitializer } from "@screens/auth/AuthInitializer";
import App from "./App";
import "@shared/styles/themes.css";
import "@shared/styles/index.css";
import "@shared/styles/globals.css";
import { applyTheme, readStoredTheme } from "@shared/theme/theme";

applyTheme(readStoredTheme());

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthInitializer>
          <App />
        </AuthInitializer>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>
);
